import perifoneoImagen from "../../assets/img/megafono.png"
import codigoVestimentaImagen from "../../assets/img/codigo-de-vestimenta.png"
import culturaImagen from "../../assets/img/colaboracion.png"
import puntosVenta from "../../assets/img/point-of-sale.png"

import {Button, Col, Container, Row} from "react-bootstrap";
import {ShortcutCard} from "../shortcuts/ShortcutCard";
import {CarouselNews} from "../home/CarouselNews";
import React from "react";
import {Link, useNavigate} from "react-router-dom";
// Define la URL destino para la sección de marketing (seccionId 21)
const marketingUrl = "/mercadotecnia/matriz-de-promociones";// Reemplaza con la URL que necesites



export const Marketing = () => {
    const SECCION_ID = 21;
    const navigate = useNavigate();
    const shortcuts = [{
        title: "Perifoneos",
        description: "Perifoneos",
        imgUrl: perifoneoImagen,
        url: "/mercadotecnia/perifoneos",
        backgroundColor: "rgba(102,185,179, 0.7)", // Color personalizado
        textColor: "rgb(255, 255, 255)",
    }, {
        title: "Barker",
        description: "Barker",
        imgUrl: codigoVestimentaImagen,
        url: "/mercadotecnia/barker",
        backgroundColor: "rgba(211,112,46,0.7)", // Color personalizado
        textColor: "rgb(255, 255, 255)",
    }, {
        title: "Folleteria digital",
        description: "Folleteria digital",
        imgUrl: culturaImagen,
        url: "/mercadotecnia/folleteria-digital",
        backgroundColor: "rgba(241,207,73,0.7)", // Color personalizado
        textColor: "rgb(255, 255, 255)",
    }, {
        title: "Puntos de venta",
        description: "Punto de venta",
        imgUrl: puntosVenta,
        url: "/mercadotecnia/puntos-de-venta",
        backgroundColor: "rgba(188,43,108,0.7)", // Color personalizado
        textColor: "rgb(255, 255, 255)",
    },];

    return (
        <section className="shortcut-marketing" id="shortcut-marketing">
            <Container>
                <div className={"banner-transparente"}>
                    <h1 className="banner-title">Mercadotecnia</h1>
                    <p className="banner-description">Bienvenido a mercadotecnia, donde la creatividad y la innovación
                        se unen para impulsar tus ventas</p>
                </div>
                <div className="d-flex justify-content-center">
                    <Button
                        className="button_id mt2 btn btn-primary"
                        onClick={() => window.open(marketingUrl, "_self")}
                    >
                        Click aquí para todas las promociones
                    </Button>
                </div>

                <CarouselNews seccionId={SECCION_ID}/>
                <Row className={"justify-content-center pt-5 pb-5"}>
                    {shortcuts.map((shortcut, index) => (<Col key={index} xs={6} sm={3} md={3} lg={2}>
                        <ShortcutCard {...shortcut} />
                    </Col>))}
                </Row>
            </Container>
        </section>
    )
}
